import classnames from 'classnames/bind'
import InputForCopy from 'components/input_for_copy'
import PropTypes from 'prop-types'
import QRCode from 'qrcode.react'
import React, { Component } from 'react'
import styles from './url_publisher.module.scss'

const cx = classnames.bind(styles)
// TODO [locales] I18nを呼べるようにしてから対応 components.url_publisher.default_text
const DEFAULT_TEXT = 'Control + C でコピーして社内SNSなどで共有してください'

export default class UrlPublisher extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
      targetY: null,
      modalHeight: null
    }
  }

  setModalHeight() {
    this.setState({
      modalHeight: this.modal.clientHeight
    })
  }

  show(e) {
    const targetY = document.body.clientHeight - e.pageY

    this.setState(
      {
        isOpen: true,
        targetY
      },
      () => this.setModalHeight()
    )
  }

  hide() {
    this.setState({
      isOpen: false
    })
  }

  render() {
    const { additionalButtonClass, available, children, icon, name, qrcode, url } = this.props

    if (!available) {
      return null
    }

    const { isOpen, targetY, modalHeight } = this.state
    const isTop = targetY < modalHeight

    return (
      <div
        className={cx(styles.publisher, {
          publisherActive: isOpen,
          qrcodeActive: qrcode
        })}
      >
        <button
          type="button"
          className={cx(styles.button, additionalButtonClass, {
            buttonActive: isOpen
          })}
          onClick={e => this.show(e)}
          disabled={!available}
        >
          {icon ? <i className={icon} /> : null}
          {name}
        </button>
        {isOpen ? <div className={styles.publisherBg} onClick={() => this.hide()} role="presentation" /> : null}
        {isOpen ? (
          <div
            className={cx(styles.publisherModal, { publisherModalTop: isTop, publisherModalBottom: !isTop })}
            ref={ref => {
              this.modal = ref
            }}
          >
            {children === null ? <div className={styles.publisherText}>{DEFAULT_TEXT}</div> : children}
            <InputForCopy value={url} />
            {qrcode ? (
              <div className={styles.publisherQrcode}>
                <QRCode value={url} size={120} includeMargin />
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    )
  }
}

UrlPublisher.propTypes = {
  available: PropTypes.bool,
  additionalButtonClass: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  icon: PropTypes.string,
  name: PropTypes.string,
  qrcode: PropTypes.bool,
  url: PropTypes.string.isRequired
}

UrlPublisher.defaultProps = {
  available: true,
  additionalButtonClass: null,
  children: null,
  icon: null,
  name: null,
  qrcode: true
}
